// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__35Mz0","header":"ReportDetails_header__1af8M","title":"ReportDetails_title__XeerA","left":"ReportDetails_left__39dn-"};